import http from '@/libs/http'
export default class CientesServices {
  getClientes () {
    // return http.get(`${process.env.VUE_APP_MICROSERVICE_API_FACTURACION}/clientes`)
    return http.get(`${process.env.VUE_APP_MICROSERVICE_API_UT_SEGUPHARMA_CONFIG_OV}/ov-cliente/listar`)
  }
}
